<p><!-- Transport Pickup Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Transport Pickup Listing Component -->
  <app-transport-pickup-listing #transportPickupListing>
  </app-transport-pickup-listing>
</div>

<!-- Transport Pickup Add/Edit Modal -->
<app-transport-pickup-add
  (transportPickupAdded)="onTransportPickupAdded()"
  (transportPickupUpdated)="onTransportPickupUpdated()">
</app-transport-pickup-add>

<!-- Transport Pickup Bulk Update Modal -->
<app-transport-pickup-bulk-update
  (bulkUpdated)="onTransportPickupUpdated()">
</app-transport-pickup-bulk-update>
